import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://lhcuuanrdpdyeffncdeg.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxoY3V1YW5yZHBkeWVmZm5jZGVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY4NjYyMzEsImV4cCI6MjA5MjQ0MjIzMX0.yKKvu0-vHxYcnmjeG6pze5e9S5rYplQ25p72pdNQFJc';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
